import { List, Map } from "immutable";

import { composeSelector } from "seneca-common/utils/selectors/compose-selectors";

import Session from "../../../models/Session";
import * as sessionSelectors from "./session";

function getSession(
  sessions: Map<string, Session>,
  sessionId: string
): Session {
  return sessions.get(sessionId) as Session;
}

function composeSessionSelector<T>(
  selector: (arg0: Session) => T
): (sessions: Map<string, Session>, sessionId: string) => T {
  return composeSelector(getSession, selector);
}

export const getSessionCompleted = composeSessionSelector(
  sessionSelectors.getCompleted
);
export const getNumberOfSessionModules = composeSessionSelector(
  sessionSelectors.getNumberOfSessionModules
);

export function getCompletedSessions(
  sessions: Map<string, Session>
): Map<string, Session> {
  return sessions.filter(session => sessionSelectors.getCompleted(session));
}

export function getNumberOfCompletedSessions(sessions: Map<string, Session>) {
  return getCompletedSessions(sessions).size;
}

export function orderSessionsByEndTimeAsc(
  sessions: List<Session>
): List<Session> {
  return sessions.sortBy(sessionSelectors.getEndTimeUnix);
}

export function getActiveSectionSessionId(
  sessions: Map<string, Session>,
  sectionId: string
): string | null | undefined {
  const session = sessions
    .toList()
    .filter(session => sessionSelectors.isSessionForSection(session, sectionId))
    .sortBy(sessionSelectors.getStartTimeUnix)
    .last();

  if (!session) return null;

  return sessionSelectors.getId(session);
}
